import { useEffect, useRef } from "react";
import Chart from "chart.js/auto";

const ResultsChart = (props) => {
  const { chartHeader, success, failed } = props;
  const chartRef = useRef(null);

  useEffect(() => {
    const data = {
      labels: ["Successful", "Failed"],
      datasets: [
        {
          label: "Label review results",
          data: [success, failed],
          backgroundColor: ["#367c2b", "#c21020"],
          borderColor: "#fff",
          borderWidth: 2,
          hoverOffset: 4,
        },
      ],
    };

    const config = {
      type: "doughnut",
      data: data,
      options: {
        plugins: {
          title: {
            display: true,
            text: chartHeader,
          },
        },
      },
    };

    const chart = new Chart(chartRef.current, config);

    return () => {
      chart.destroy();
    };
  }, [chartHeader, success, failed]);

  return (
    <div>
      <h2>{chartHeader}</h2>
      <canvas ref={chartRef} height={280}></canvas>
    </div>
  );
};

export default ResultsChart;
